import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ModalFooter as ChakraModalFooter, } from '@chakra-ui/react';
/**
 * ModalFooter houses any action buttons of the modal.
 * When sibling element ModalBody is overflowing the ModalFooter will be
 * displayed with a box shadow indicating the overflow of the ModalBody.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/modal
 */
export function ModalFooter({ children, ...props }) {
    const [showShadow, setShowShadow] = useState(false);
    // Set up a resize observer of the sibling element ModalBody to identify when modal content is overflowing
    const resizeObserver = new ResizeObserver((entries) => {
        const modalBody = entries[0].target;
        const isModalBodyContentOverflowing = modalBody.scrollHeight > modalBody.clientHeight;
        setShowShadow(isModalBodyContentOverflowing);
    });
    useEffect(() => {
        const modalBody = document.querySelector("[id^='chakra-modal--body']");
        if (modalBody) {
            resizeObserver.observe(modalBody);
        }
        return () => {
            // Clean up on unmount, stop observning
            if (modalBody)
                resizeObserver.unobserve(modalBody);
        };
    }, []);
    const boxShadow = showShadow ? '0px 0px 16px rgba(0, 0, 0, 0.24)' : 'none';
    return (_jsx(ChakraModalFooter, { boxShadow: boxShadow, ...props, children: children }));
}
//# sourceMappingURL=modalFooter.js.map